<template>
  <div class="slider-div">
    <div class="container">
      <div class="slider-content" v-if="homeSetting.home_title">
        <h1>{{ homeSetting.home_title }}</h1>
        <p v-html="homeSetting.home_description"></p>
      </div>
      <div v-else class="py-16 my-16">
        <v-skeleton-loader class="bg-transparent" type="article" width="500"></v-skeleton-loader>
      </div>

      <filterSpace/>
    </div>
  </div>
</template>

<script>
import filterSpace from "./filter/filter-space.vue";

export default {
  props: ["homeSetting"],
  components: {
    filterSpace,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.slider-div .slider-content {
  text-align: start;
  margin: 180px 0 55px 0;
  width: 60%;
  padding: 0 24px;
}

.slider-div .slider-content h1 {
  color: #000;
  font-size: 56px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 67.2px */
  margin-bottom: 45px;
}

.slider-div .slider-content p {
  color: #3C3C3C;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px; /* 128.571% */
  width: 60%;
}

@media (max-width: 768px) {
  .slider-div .slider-content {
    width: 100%;
    padding: 0;
  }

  .slider-div .slider-content h1 {
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 40px;
    font-weight: 600;
  }

  .slider-div .slider-content p {
    font-size: 16px;
    line-height: 24px;
    width: 100%;
    font-weight: 600;
  }
}
</style>
